import {COLLECTION_USER} from './constants';

export function getUsersCollectionPath(): string {
  return `${COLLECTION_USER}`;
}
